import React, { useRef } from "react";
import "./prodHuntPopup.scss";
import { Portal } from '@shared';
import { Text, Icon } from "@ui-kit";
const CloseIcon = "/images/icons/x-gray700.svg";

const ProductHunt = () => {
    const prodHuntEl = useRef(true);

    const closeProdHunt = () => {
        localStorage.setItem('accept_producthunt', true);
        prodHuntEl.current.classList.add("hidden");
    }

    return (
        <Portal className="portal-prod-hunt">
           <div className="prod-hunt__container" ref={prodHuntEl}>
                <div className="prod-hunt__content">
                    <Text as="h5" className="prod-hunt__title">Please support us with your vote on ProductHunt!</Text>

                    <a className="product-hunt-badge" href="https://www.producthunt.com/products/flowpik?embed=true&amp;utm_source=badge-featured&amp;utm_medium=badge&amp;utm_campaign=badge-flowpik" target="_blank" rel="noopener noreferrer">
                        <img alt="FlowPik - Unlimited custom illustrations on a Subscription! | Product Hunt" width="250" height="54" src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1161604&amp;theme=neutral&amp;t=1780583812598"/>
                    </a>
                </div>
                <div className="prod-hunt__actions">
                    <div className="prod-hunt-close" onClick={closeProdHunt}>
                        <Icon src={CloseIcon} />
                    </div>
                </div>
           </div>
        </Portal>
    )
}

export default ProductHunt;